
















import Vue from "vue";
import { SET_PROGRESS } from "@/constants/mutation-types";

export default Vue.extend({
  name: "OnboardingDenied",
  mounted() {
    this.$store.commit(SET_PROGRESS, 0);
  },
  data() {
    return {
      TRANSLATION_KEY: "steps.OnboardingDenied",
    };
  },
});
